var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow flex mx-correction relative"},[_c('div',{ref:"stack",staticClass:"mt-16 lg:mt-24 transition-opacity flex-grow absolute-childeren"},[_vm._t("default",null,{"handleLoad":_vm.handleLoad})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }